<script lang="ts" setup>
/**
 * UI-kit component
 * Category: Loaders
 * Name: LoaderBlockDomain
 * FIGMA: https://www.figma.com/design/n8yjfgcFUgYPq4BLYjeYcJ/Design-System--Client?node-id=22864-46
 */
import { Loader } from '@brighterly/lib-lumee-ui'

import type { LoaderBlockDomainProps } from './interfaces'

import { useAppBrand } from '@shared/lib/app-brand'

import { LoaderSmartestMinds } from './index'

defineOptions({
  name: 'LoaderBlockDomain',
})

const { size = 'lg' } = defineProps<LoaderBlockDomainProps>()

const { isSmartestMinds } = useAppBrand()
</script>

<template>
  <div class="loader-block-domain">
    <LoaderSmartestMinds
      v-if="isSmartestMinds"
      :size="size"
    />
    <Loader
      v-else
      view="brand"
      :size="size"
    />
  </div>
</template>

<style lang="scss" scoped src="./_loader-block-domain.scss" />
